// extracted by mini-css-extract-plugin
export default {"dialog":"SessionMonitorComponent_dialog__4TEN8","box":"SessionMonitorComponent_box__8mssd"};